<template>
    <div class="container type3" @click="$event.stopPropagation();">
        <div class="month">
            <a style="margin-left: 10px;" href="javascript:void(0)" @click="showPrevMonth"><img :src="require('@/assets/img/back_btn_black_new.png')"></a>
            <span>{{ year }}년 {{ month }}월</span>
            <a style="margin-right: 10px; transform: rotate(180deg);" href="javascript:void(0)" @click="showNextMonth"><img :src="require('@/assets/img/back_btn_black_new.png')"></a>
        </div>
        <div class="date">
            <ul>
                <li>일</li>
                <li>월</li>
                <li>화</li>
                <li>수</li>
                <li>목</li>
                <li>금</li>
                <li>토</li>
            </ul>
            <div class="calendar_wrap" :style="{ height: curHeight + 'px' }">
                <div class="calendar_location" :style="{ top: '-' + (selectedWeekIndex * eachWeekHeight) + 'px' }">
                    <ul v-for="week, i in monthData" :key="i">
                        <li :class="[selectedRowIndex == i && selectedColIndex == j ? 'active' : '', day.key == todayStr ? 'active_text' : '']" v-for="day, j in week" @click="selectDate(i, j)" :key="i + '-' + j">
                            <div class="calendar_today_mark" v-if="day.key == todayStr"></div>
                            <span class="calendar_date_text" :class="[day.key && (day.key.substr(0, 4) === year && parseInt(day.key.substr(5, 2)) === parseInt(month)) ? '' : 'not_cur_month']">{{ day.date == 0 ? '' : day.date }}</span>
                            <div class="calendar_additional_info_wrap" v-if="additionalInfo.hasOwnProperty(day.key)">
                                <div class="calendar_additional_info_round expired" v-if="additionalInfo[day.key].hasOwnProperty('expired')"></div>
                                <div class="calendar_additional_info_round available" v-if="additionalInfo[day.key].hasOwnProperty('available') || additionalInfo[day.key].hasOwnProperty('canceled') || additionalInfo[day.key].hasOwnProperty('waiting_available')"></div>
                                <div class="calendar_additional_info_round complete" v-if="additionalInfo[day.key].hasOwnProperty('complete')"></div>
                                <div class="calendar_additional_info_round others" v-if="additionalInfo[day.key].hasOwnProperty('others')"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import calendar from '@/modules/calendar';
//const cal = new calendar();

export default {
    name: "CalendarClass",
    props: ['selectDateCallback', 'startDate', 'monthChangeHandler', 'detectMonthChangeCall', 'isToggleHidden', 'isFirstShowMonth', 'isModify'],
    data() {
        return {
            monthData: [],
            year: '',
            month: '',
            eachWeekHeight: 48,
            showAll: true,
            selectedWeekIndex: 0,
            curHeight: this.eachWeekHeight,
            selectedRowIndex: -1,
            selectedColIndex: -1,
            additionalInfo: {},
            lastSelectedYear: '',
            lastSelectedMonth: '',
            lastSelectedRowIndex: -1,
            lastSelectedColIndex: -1,
            todayStr: '',
            execCnt: 0,
            cal: null,

        }
    },
    watch: {
        detectMonthChangeCall() {
            this.handleMonthChange();
        }
    },
    methods: {
        toggleCalendar() {
            //$(".hide").slideToggle(300);
            this.resizeCalendar(true);
        },
        closeCalendar() {
            this.resizeCalendar(false);
        },
        resizeCalendar(isShowMore = false) {
            //열때
            if (this.showAll) {
                this.selectedWeekIndex = 0;
                this.curHeight = this.eachWeekHeight * this.cal.getWeekCnt();
                //닫을때
            } else {
                // if(this.cal.isTodayMonth()){
                this.selectedWeekIndex = this.lastSelectedRowIndex;
                //this.selectedWeekIndex = this.cal.getSelectedWeekIndex();
                // }else {
                //     this.selectedWeekIndex = 0;
                // }

                this.curHeight = this.eachWeekHeight;
            }

            if (!isShowMore) {
                if (this.execCnt < 2) {
                    this.selectedRowIndex = this.cal.getSelectedWeekIndex();
                    this.selectedColIndex = this.cal.getSelectedColIndex();
                    this.lastSelectedRowIndex = this.cal.getSelectedWeekIndex();
                    this.lastSelectedColIndex = this.cal.getSelectedColIndex();
                    this.lastSelectedMonth = this.month;
                    this.lastSelectedYear = this.year;
                    this.execCnt++;
                } else {
                    if (this.month == this.lastSelectedMonth && this.year == this.lastSelectedYear) {
                        this.selectedRowIndex = this.lastSelectedRowIndex;
                        this.selectedColIndex = this.lastSelectedColIndex;
                    } else {
                        this.selectedRowIndex = -1;
                        this.selectedColIndex = -1;
                    }
                }
            }
        },
        getMonthData() {
            this.monthData = this.cal.getMonthData();
            this.year = this.cal.getYear();
            this.month = parseInt(this.cal.getMonth());
            this.resizeCalendar();
        },
        showPrevMonth() {
            this.cal.setPrevMonth();
            this.handleMonthChange();
        },
        showNextMonth() {
            this.cal.setNextMonth();
            this.handleMonthChange();
        },
        handleMonthChange() {
            this.getMonthData();
            if (this.monthChangeHandler != null) {
                this.monthChangeHandler((additionalInfo) => {
                    this.additionalInfo = additionalInfo;
                    this.getMonthData();
                }, this.cal.getYear(), this.cal.getMonth());
            }
        },
        selectDate(i, j) {
            this.selectedRowIndex = i;
            this.selectedColIndex = j;
            this.lastSelectedRowIndex = i;
            this.lastSelectedColIndex = j;
            this.lastSelectedYear = this.year;
            this.lastSelectedMonth = this.month;
            if (this.cal.getDateStrBy(i, j) === '') return;
            // if(this.cal.getDateStrBy(i,j) === 'Invalid date()');
            this.selectDateCallback(this.cal.getDateStrBy(i, j));
            // this.closeCalendar();
        },

    },
    mounted() {
        this.cal.init(this.startDate);
        //cal.setChangeMonthHandler(this.monthChangeHandler);
        this.handleMonthChange();
    },
    created() {
        this.cal = new calendar();
        this.todayStr = moment().format('YYYY-MM-DD');
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family)
}

ul {
    list-style: none;
    margin: 0px;
    padding: 0px;
}

.container.type3 {
    width: 100%;
    box-sizing: border-box;
    background-color: white;
}

.month {
    /* width: 200px; */
    margin: 0px auto;
    overflow: hidden;
    line-height: 1;
    text-align: center;
    display: flex;
    justify-content: space-between;
}

.month img {
    width: 100%;
    height: auto;
}

.month a {
    width: 7px;
    display: inline-block;
    padding: 11px 10px;
    vertical-align: top;
    box-sizing: content-box;
}

.month span {
    text-align: center;
    color: #101014;
    font-size: 20px;
    display: inline-block;
    padding: 10px 0px;

}

.date ul {
    width: 100%;
    overflow: hidden;
    display: table;
}

.date>ul:first-child li {
    color: #333;
    /* font-weight: bold; */
}

.date li {
    /* color: #888; */
    font-size: 15px;
    display: table-cell;
    width: 14.28%;
    padding: 15px 0;
    box-sizing: border-box;
    text-align: center;
    position: relative;
}

.date li.active {
    background: #eaf5fd;
    color: #000;
    border-radius: 3px;
}

.date>ul:first-child li.active {
    background: none;
}

.date ul li:first-child {
    color: #ee5844;

}

.date ul li:last-child {
    color: #17A1FA;
}

.date .hide {
    display: none;
}

.date .toggle {
    width: 100%;
    display: block;
    border-radius: 3px;
    border: 1px solid #ddd;
    text-align: center;
    text-indent: -9999px;
    padding: 10px 0;
    overflow: hidden;

}

.calendar_toggle {
    /*background: url(../images/more2.png) no-repeat center/19px auto;*/
    transition: transform 0.3s ease-in;
}

.calendar_toggle.active {
    transform: rotate(180deg);
}

.date .toggle.active {
    /*background: url(../images/return.png) no-repeat center/19px auto;*/
}


.calendar_wrap {
    position: relative;
    overflow: hidden;
    height: 48px;
    transition: height .3s ease;
}

.calendar_location {
    position: absolute;
    top: 0px;
    width: 100%;
    transition: top .3s ease;
}

.calendar_additional_info_wrap {
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
}

.calendar_additional_info_round {
    width: 6px;
    height: 6px;
    border-radius: 3px;
    display: inline-block;
    background-color: #c1e3fc;
    margin: 0px 1px;
}

.calendar_additional_info_round+.calendar_additional_info_round {
    margin-left: 3px;
}

.expired {
    background-color: red;
}

.available {
    background-color: #4c84ff;
}

.complete {
    background-color: #c1e3fc;
}

.others {
    background-color: #7587ad;
}

.calendar_today_mark {
    background-color: var(--color-main);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 24px;
    height: 24px;
    border-radius: 50%;
}

.calendar_date_text {
    position: relative;
}

.calendar_date_text.not_cur_month {
    color: #B3B3B3;
}

.active_text {
    color: #fff !important;
}
</style>